<template>
  <div class="avatar-plug" :style="`border-radius: ${borderRadius}; width: ${width}px; minWidth: ${width}px;  height: ${height}px; font-size: ${letterSize}`">
    {{letter}}
  </div>
</template>



<style scoped lang="scss">
.avatar-plug{
  background-color: #e1e1e1;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #676666;

  width: 100%;

}
</style>

<script>
export default {
  props: {
    borderRadius:{
      type: String,
      default: '50%'
    },
    letterSize:{
      type: String,
      default: '26px'
    },
    letter: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: 60
    }
  }
}
</script>

